import * as React from 'react'
import Image from 'next/image'
import { Container } from '../Container'
import { GraySection } from '../GraySection'

import warranty from '../../../public/img/nubrakes-warranty.png'
import timeClock from '../../../public/img/time-icon@3x.png'

type Props = {
  title: string
  subheading1: string
  subheading2: string
  paragraphs: string[]
}

export const V2BookFactsSection: React.FC<Props> = ({ title, subheading1, subheading2, paragraphs }) => (
  <GraySection className="text-center">
    <Container>
      <h2 className="title">{title}</h2>
      <p className="description">{subheading1}</p>
      <style jsx global={true}>{`
        .facts-block {
          background-color: white;
          border: 1px solid rgb(234, 209, 202);
        }

        .small-header {
          font-size: 18px;
          font-weight: 800;
          line-height: 1.33;
          color: #1a1919;
        }
      `}</style>
      <div className="grid lg:grid-cols-12">
        <div className="lg:col-span-8 facts-block">
          <FactsPane shpealTitle={subheading2} paragraphs={paragraphs} />
        </div>
        <div className="lg:col-span-4 facts-block">
          <FactsSideBar />
        </div>
      </div>
    </Container>
  </GraySection>
)

type FactsPaneProps = {
  shpealTitle: string
  paragraphs: string[]
}

const FactsPane: React.FC<FactsPaneProps> = ({ shpealTitle, paragraphs }) => (
  <div className="text-left p-12">
    <h3>{shpealTitle}</h3>
    {paragraphs &&
      paragraphs.map((p, index) => (
        <p key={index} className="description">
          {p}
        </p>
      ))}
  </div>
)

const FactsSideBar: React.FC = () => {
  const FactsSideBarItem: React.FC<{
    image: any
    title: string
    description: string
  }> = ({ title, description, image }) => (
    <div className="text-center">
      <Image src={image} width={50} height={50} alt={title} className="mx-auto" />
      <h4 className="small-header">{title}</h4>
      <p>{description}</p>
    </div>
  )
  return (
    <div className="p-12">
      <div className="pb-3">
        <h2 className="small-header mb-0">Additional Perks</h2>
        <h2 className="small-header">of Choosing NuBrakes</h2>
      </div>
      <FactsSideBarItem
        title={'Top Rated Warranty'}
        description={`Every brake repair comes with our NuBrakes Guarantee.`}
        image={warranty}
      />
      <FactsSideBarItem
        title={'On-Demand Service'}
        description={`We make sure to work around your schedule, not against it.`}
        image={timeClock}
      />
    </div>
  )
}
